











import { Vue, Component, Prop } from 'vue-property-decorator'
import confirm from 'components/modals/Confirm'
import api from 'src/assets/api/gql'
import StudentUpdate from 'src/graphql/student/StudentUpdate.gql'
import { Student } from 'src/graphql/types'

@Component
export default class ItemCourseStudentButtonDelete extends Vue {
  loading = false

  @Prop()
  readonly student!: Student

  async trash () {
    await confirm({
      title: this.$t('label.deleteConfirm').toString(),
      message: this.student.publicProfile?.name,
      btnRight: this.$t('label.delete').toString(),
      btnRightColor: 'warning'
    })
    this.loading = true
    await api.mutate({
      query: StudentUpdate,
      variables: {
        id: this.student.id,
        data: { deletedAt: (new Date()).toJSON() }
      }
    })
    this.loading = false
    this.$emit('delete')
  }
}
